import React, {FC} from 'react'

interface IPaystubBaseMetricsProps {
	name?: string
	employeeSocial?: string
	telephone?: string
	address1?: string
	address2?: string
	city?: string
	state?: string
	zipCode?: string
	className?: string
}

const PaystubBaseMetrics: FC<IPaystubBaseMetricsProps> = ({
	name,
	employeeSocial,
	telephone,
	address1,
	address2,
	city,
	state,
	zipCode,
	className = '',
}) => {
	return (
		<div className={`paystub-base-metrics ${className}`}>
			<div className="paystub-base-metrics__item">{name}</div>
			<div className="paystub-base-metrics__item">{employeeSocial}</div>
			<div className="paystub-base-metrics__item">{telephone}</div>
			<div className="paystub-base-metrics__item">{address1}</div>
			<div className="paystub-base-metrics__item">{address2}</div>
			<div className="paystub-base-metrics__item">
				{city && <>{city}, </>} {state} {zipCode}
			</div>
		</div>
	)
}

PaystubBaseMetrics.displayName = 'PaystubBaseMetrics'

export default PaystubBaseMetrics
